import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-teamleader-subnav',
    templateUrl: './teamleader-subnav.component.html',
    styleUrls: ['./teamleader-subnav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TeamleaderSubnavComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
